module.exports = __webpack_public_path__ + "static/media/img_Benchmarking201.d0388e07.png";